import {
  BadgeDollarSign,
  ChartLine,
  ChartNoAxesCombined,
  CircleHelp,
  Gift,
  LandPlot,
  LayoutTemplate,
  LogOut,
  MapPinPlus,
  Megaphone,
  Package,
  Boxes,
  Send,
  Store,
  UserRoundPen,
  WalletMinimal,
  Warehouse,
  GitBranchPlus,
} from "lucide-react";
import { PERMISSIONS } from "./config/permissions";

const Links = [
  {
    type: "Deals",
    name: "Manage Your Deals",
    icon: (
      <BadgeDollarSign className="transition duration-300 group-hover:text-white" />
    ),
    link: "/offers",
    permissions: {
      module: PERMISSIONS.MODULES.DEALS_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.VIEW_DEALS,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Deals",
    name: "Deal Redemptions",
    icon: <Gift className="transition duration-300 group-hover:text-white" />,
    link: "/redeem-offers",
    permissions: {
      module: PERMISSIONS.MODULES.REDEEM_OFFERS,
      action: PERMISSIONS.ACTIONS.REDEEM_OFFERS,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Orders",
    name: "Orders",
    icon: (
      <Package className="transition duration-300 group-hover:text-white" />
    ),
    link: "/orders",
    permissions: {},
  },
  {
    type: "Orders",
    name: "Inventory",
    icon: (
      <Boxes className="transition duration-300 group-hover:text-white" />
    ),
    link: "/inventory",
    permissions: {
      module: PERMISSIONS.MODULES.DEALS_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.EDIT_OFFER,
      fallbackForMainVendor: true,
    },
  },
  // {
  //   type: "Affiliates",
  //   name: "Affiliates",
  //   icon: <Cannabis className="transition duration-300 group-hover:text-white" />,
  //   link: "/affiliates",
  //   permissions: {},
  // },
  {
    type: "Affiliates",
    name: "Affiliate Applications",
    icon: (
      <Megaphone className="transition duration-300 group-hover:text-white" />
    ),
    link: "/affiliate-applications",
    permissions: {},
  },
  {
    type:"Branches",
    name:"Branches",
    icon: (
      <Warehouse className="transition duration-300 group-hover:text-white" />
    ),
    link: "/branches",
    permissions: {
      module: PERMISSIONS.MODULES.BRANCH_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.VIEW_BRANCHES,
      fallbackForMainVendor: true,
    },
  },
  {
    type:"Branches",
    name:"Add New Branch",
    icon: (
      <GitBranchPlus className="transition duration-300 group-hover:text-white" />
    ),
    link: "/add-branch",
    permissions: {
      module: PERMISSIONS.MODULES.BRANCH_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.CREATE_BRANCH,
      fallbackForMainVendor: true,
    }
  },
  {
    type: "Partners",
    name: "Partners",
    icon: <Store className="transition duration-300 group-hover:text-white" />,
    link: "/partners",
    permissions: {
      module: PERMISSIONS.MODULES.PARTNER_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.VIEW_PARTNERS,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Partners",
    name: "Add New Partner",
    icon: (
      <MapPinPlus className="transition duration-300 group-hover:text-white" />
    ),
    link: "/add-partner",
    permissions: {
      module: PERMISSIONS.MODULES.PARTNER_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.CREATE_PARTNER,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Deals",
    name: "Reports and Analytics",
    icon: (
      <ChartLine className="transition duration-300 group-hover:text-white" />
    ),
    link: "/reporting-and-analytics",
    permissions: {
      module: PERMISSIONS.MODULES.DEALS_ANALYTICS,
      action: PERMISSIONS.ACTIONS.VIEW_REPORTS_ANALYTICS,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Settings",
    name: "Roles & Permissions",
    icon: (
      <LandPlot className="transition duration-300 group-hover:text-white" />
    ),
    link: "/roles-and-permissions",
    permissions: {
      module: PERMISSIONS.MODULES.ROLES_PERMISSION,
      action: PERMISSIONS.ACTIONS.ROLE_VIEW,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Settings",
    name: "Manage Subscription",
    icon: (
      <WalletMinimal className="transition duration-300 group-hover:text-white" />
    ),
    link: "/subscription",
    permissions: {
      module: PERMISSIONS.MODULES.SUBSCRIPTION,
      action: PERMISSIONS.ACTIONS.VIEW_SUBSCRIPTION,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Settings",
    name: "Subscription Plans",
    icon: (
      <WalletMinimal className="transition duration-300 group-hover:text-white" />
    ),
    link: "/pricing",
    permissions: {
      module: PERMISSIONS.MODULES.SUBSCRIPTION,
      action: PERMISSIONS.ACTIONS.PURCHASE_SUBSCRIPTION,
      fallbackForMainVendor: true,
    },
  },
  {
    type: "Settings",
    name: "My Store",
    icon: (
      <LayoutTemplate className="transition duration-300 group-hover:text-white" />
    ),
    link: "/my-store",
    permissions: {
      module: null,
      action: null,
      alwaysVisible: true,
    },
  },
  {
    type: "Settings",
    name: "Profile Settings",
    icon: (
      <UserRoundPen className="transition duration-300 group-hover:text-white" />
    ),
    link: "/profile-settings",
    permissions: {
      // Profile settings should be accessible to everyone
      module: null,
      action: null,
      alwaysVisible: true,
    },
  },
  {
    type: "Campaigns",
    name: "What We Offer",
    icon: (
      <ChartNoAxesCombined className="transition duration-300 group-hover:text-white" />
    ),
    link: "/campaigns/overview",
    permissions: {
      // Campaign overview should be accessible to everyone
      module: null,
      action: null,
      alwaysVisible: true,
    },
  },
  {
    type: "Campaigns",
    name: "Manage Sender-ID",
    icon: <Send className="transition duration-300 group-hover:text-white" />,
    link: "/campaigns/senders",
    permissions: {
      module: PERMISSIONS.MODULES.DEALS_MANAGEMENT,
      action: PERMISSIONS.ACTIONS.BLAST_DEAL,
      fallbackForMainVendor: true,
    },
  },
  // {
  //   type: "Campaigns",
  //   name: "All Campaigns",
  //   icon: (
  //     <RadioTower className="transition duration-300 group-hover:text-white" />
  //   ),
  //   link: "/deal/campaigns",
  //   permissions: {
  //     module: PERMISSIONS.MODULES.DEALS_MANAGEMENT,
  //     action: PERMISSIONS.ACTIONS.VIEW_DEALS,
  //     fallbackForMainVendor: true
  //   }
  // },
  // {
  //   type: "Campaigns",
  //   name: "Campaign Redemptions",
  //   icon: (
  //     <Megaphone className="transition duration-300 group-hover:text-white" />
  //   ),
  //   link: "/redeem-campaigns",
  //   permissions: {
  //     module: PERMISSIONS.MODULES.REDEEM_OFFERS,
  //     action: PERMISSIONS.ACTIONS.REDEEM_OFFERS,
  //     fallbackForMainVendor: true
  //   }
  // },
  {
    type: "Help",
    name: "Help & Support",
    icon: (
      <CircleHelp className="transition duration-300 group-hover:text-white" />
    ),
    link: "/help-and-support",
    permissions: {
      // Help should be accessible to everyone
      module: null,
      action: null,
      alwaysVisible: true,
    },
  },
  {
    type: "Help",
    name: "Logout",
    icon: <LogOut className="transition duration-300 group-hover:text-white" />,
    link: "button",
    permissions: {
      // Logout should always be visible
      module: null,
      action: null,
      alwaysVisible: true,
    },
  },
];

export default Links;
